export interface Task {
  id: string;
  title: string;
  assignee: string;
  client: string;
  deadline: string;
  priority: string;
  status: string;
}

export interface ManagerKPI {
  name: string;
  newClients: number;
  calls: number;
  proposals: number;
  invoices: number;
  payments: number;
  conversion: number;
  discipline: number;
  revenue: number;
  margin: number;
}

export interface ClientAnalysis {
  name: string;
  totalRevenue: number;
  totalMargin: number;
  ordersCount: number;
  lastOrderDate: string;
  status: string;
  debt: number;
  trend: string;
  trendPercent: number;
}

export interface DepartmentStage {
  name: string;
  count: number;
  value: number;
  conversion: number;
  lossReason: string;
}

export interface ReportTemplate {
  name: string;
  type: string;
  lastGenerated: string;
  autoSchedule: boolean;
  description: string;
}

export interface StuckDeal {
  id: string;
  client: string;
  manager: string;
  amount: number;
  daysWithoutAction: number;
  lastAction: string;
}

export interface DormantClient {
  name: string;
  manager: string;
  lastOrderDate: string;
  daysSinceOrder: number;
  totalRevenue: number;
  avgOrder: number;
}

export interface UnpaidInvoice {
  id: string;
  client: string;
  manager: string;
  amount: number;
  date: string;
  daysOverdue: number;
}

export interface AIInsight {
  type: string;
  count: number;
  description: string;
  action: string;
  priority: string;
}

export interface LostDeal {
  id: string;
  client: string;
  manager: string;
  amount: number;
  stage: string;
  reason: string;
  lostDate: string;
}

export interface UnansweredOffer {
  id: string;
  client: string;
  manager: string;
  amount: number;
  sentDate: string;
  daysWithoutAnswer: number;
}

export interface DecliningClient {
  name: string;
  manager: string;
  prevRevenue: number;
  currentRevenue: number;
  declinePercent: number;
  lastOrderDate: string;
}

export interface ForgottenClient {
  name: string;
  manager: string;
  lastContactDate: string;
  daysWithoutContact: number;
  totalRevenue: number;
}

export interface RepeatSalePotential {
  client: string;
  manager: string;
  previousRevenue: number;
  potentialRevenue: number;
  category: string;
  reason: string;
}

export interface AITaskSuggestion {
  id: string;
  title: string;
  assignee: string;
  client: string;
  reason: string;
  priority: string;
  confirmed: boolean;
}

export interface DepartmentWeakSpot {
  stage: string;
  issue: string;
  lostRevenue: number;
  recommendation: string;
}

export interface ManagerLagging {
  name: string;
  metric: string;
  value: string;
  departmentAvg: string;
  gap: string;
}

export interface DepartmentManager {
  name: string;
  grade: "Менеджер" | "Ведущий менеджер";
  rating: number;
  maxRating: number;
  activeDeals: number;
  activeDealsAmount: number;
  unansweredOffers: number;
  unansweredOffersAmount: number;
  ordersInProgress: number;
  ordersInProgressAmount: number;
  warehouseAssembly: number;
  deliveriesToday: number;
  clientsWithDebt: number;
  debtAmount: number;
  paymentsToday: number;
  paymentsAmount: number;
}

export interface DepartmentData {
  name: string;
  managers: DepartmentManager[];
}

export const tasks: Task[] = [
  { id: "З-001", title: "Позвонить клиенту ООО ТексПром по счету № С-440", assignee: "Иванов А.С.", client: "ООО ТексПром", deadline: "2026-06-23", priority: "Высокий", status: "Новая" },
  { id: "З-002", title: "Отправить КП на ткань костюмную КС-400", assignee: "Петров Д.Н.", client: "АО Модный Дом", deadline: "2026-06-23", priority: "Высокий", status: "Новая" },
  { id: "З-003", title: "Напомнить об оплате счета № С-112", assignee: "Сидорова Е.М.", client: "ООО Домашний Текстиль", deadline: "2026-06-23", priority: "Высокий", status: "Новая" },
  { id: "З-004", title: "Подготовить образцы вискозы для отправки", assignee: "Иванов А.С.", client: "ООО ТекстильПро", deadline: "2026-06-24", priority: "Средний", status: "Новая" },
  { id: "З-005", title: "Перезвонить по просроченному заказу Т000-000127", assignee: "Сидорова Е.М.", client: "ООО ТексПром", deadline: "2026-06-23", priority: "Высокий", status: "Новая" },
  { id: "З-006", title: "Согласовать сроки отгрузки для заказа Т000-000118", assignee: "Петров Д.Н.", client: "ООО Швейное Объединение Восток", deadline: "2026-06-24", priority: "Высокий", status: "Новая" },
  { id: "З-007", title: "Отправить прайс на трикотаж клиенту Иголочка", assignee: "Иванов А.С.", client: "ООО Иголочка", deadline: "2026-06-24", priority: "Средний", status: "Новая" },
  { id: "З-008", title: "Встреча с ООО Гардинная Мануфактура — обсуждение скидок", assignee: "Петров Д.Н.", client: "ООО Гардинная Мануфактура", deadline: "2026-06-25", priority: "Средний", status: "Новая" },
  { id: "З-009", title: "Дожать оплату по счету № С-536", assignee: "Иванов А.С.", client: "ООО ТекстильПро", deadline: "2026-06-23", priority: "Высокий", status: "Новая" },
  { id: "З-010", title: "Уточнить потребности ООО Мебельный Текстиль — давно не заказывали", assignee: "Сидорова Е.М.", client: "ООО Мебельный Текстиль", deadline: "2026-06-24", priority: "Средний", status: "Новая" },
  { id: "З-011", title: "Проверить резерв ткани подкладочной ПД-50 для Т000-000122", assignee: "Иванов А.С.", client: "ООО Гардинная Мануфактура", deadline: "2026-06-23", priority: "Высокий", status: "Новая" },
  { id: "З-012", title: "Подготовить отчет по КПД отдела за июнь 2026", assignee: "Сидорова Е.М.", client: "Внутренний", deadline: "2026-06-24", priority: "Низкий", status: "Новая" },
];

export const managerKPIs: ManagerKPI[] = [
  { name: "Иванов А.С.", newClients: 4, calls: 42, proposals: 18, invoices: 12, payments: 9, conversion: 0.50, discipline: 0.95, revenue: 4582000, margin: 1374600 },
  { name: "Петров Д.Н.", newClients: 3, calls: 38, proposals: 15, invoices: 10, payments: 8, conversion: 0.53, discipline: 0.88, revenue: 3942000, margin: 1182600 },
  { name: "Сидорова Е.М.", newClients: 3, calls: 35, proposals: 14, invoices: 11, payments: 7, conversion: 0.50, discipline: 0.92, revenue: 5182000, margin: 1554600 },
];

export const clientAnalysis: ClientAnalysis[] = [
  { name: "ООО Швейная Фабрика №1", totalRevenue: 2458000, totalMargin: 737400, ordersCount: 5, lastOrderDate: "2026-06-20", status: "Активный", debt: 0, trend: "up", trendPercent: 12 },
  { name: "АО Модный Дом", totalRevenue: 6234000, totalMargin: 1870200, ordersCount: 5, lastOrderDate: "2026-06-21", status: "Активный", debt: 0, trend: "up", trendPercent: 8 },
  { name: "ООО Швейное Объединение Восток", totalRevenue: 3395000, totalMargin: 1018500, ordersCount: 2, lastOrderDate: "2026-05-15", status: "Снижение активности", debt: 0, trend: "down", trendPercent: -25 },
  { name: "ООО ТекстильПро", totalRevenue: 2172000, totalMargin: 651600, ordersCount: 4, lastOrderDate: "2026-06-21", status: "Активный", debt: 0, trend: "up", trendPercent: 5 },
  { name: "ООО Спецодежда Плюс", totalRevenue: 1788000, totalMargin: 536400, ordersCount: 3, lastOrderDate: "2026-06-02", status: "Активный", debt: 0, trend: "down", trendPercent: -10 },
  { name: "ООО Домашний Текстиль", totalRevenue: 1207000, totalMargin: 362100, ordersCount: 3, lastOrderDate: "2026-06-22", status: "Активный", debt: 215000, trend: "down", trendPercent: -18 },
  { name: "ООО ТексПром", totalRevenue: 714000, totalMargin: 214200, ordersCount: 2, lastOrderDate: "2026-04-22", status: "Уснувший", debt: 92000, trend: "down", trendPercent: -40 },
  { name: "ООО Гардинная Мануфактура", totalRevenue: 848000, totalMargin: 254400, ordersCount: 3, lastOrderDate: "2026-06-22", status: "Активный", debt: 204000, trend: "up", trendPercent: 3 },
  { name: "ООО Мебельный Текстиль", totalRevenue: 651000, totalMargin: 195300, ordersCount: 2, lastOrderDate: "2025-12-02", status: "Уснувший", debt: 0, trend: "down", trendPercent: -55 },
  { name: "ООО Иголочка", totalRevenue: 187000, totalMargin: 56100, ordersCount: 1, lastOrderDate: "2026-06-10", status: "Новый", debt: 0, trend: "up", trendPercent: 100 },
];

export const departmentStages: DepartmentStage[] = [
  { name: "Первичный контакт", count: 28, value: 0, conversion: 0.85, lossReason: "Нет потребности" },
  { name: "Выявление потребности", count: 24, value: 0, conversion: 0.70, lossReason: "Цена выше рынка" },
  { name: "Презентация / КП", count: 18, value: 1240000, conversion: 0.55, lossReason: "Ушли к конкурентам" },
  { name: "Согласование условий", count: 10, value: 890000, conversion: 0.80, lossReason: "Сроки не устроили" },
  { name: "Счёт выставлен", count: 9, value: 754000, conversion: 0.75, lossReason: "Отсрочка платежа" },
  { name: "Оплата получена", count: 7, value: 576000, conversion: 0.95, lossReason: "Отмена заказа" },
  { name: "Отгрузка", count: 6, value: 502000, conversion: 0.98, lossReason: "Претензии по качеству" },
  { name: "Закрытие", count: 5, value: 432000, conversion: 1.00, lossReason: "" },
];

export const reportTemplates: ReportTemplate[] = [
  { name: "Ежедневный отчет РОПа", type: "daily", lastGenerated: "2026-06-22", autoSchedule: true, description: "Сводка активности менеджеров, просрочки, ключевые показатели за день" },
  { name: "Еженедельный отчет по отделу продаж", type: "weekly", lastGenerated: "2026-06-21", autoSchedule: true, description: "Динамика продаж, план/факт, рекомендации за неделю" },
  { name: "Ежемесячный отчет руководителю", type: "monthly", lastGenerated: "2026-06-01", autoSchedule: true, description: "Сводный отчет по выручке, марже, KPI за месяц" },
  { name: "Отчет по KPI менеджеров", type: "kpi", lastGenerated: "2026-06-20", autoSchedule: true, description: "Показатели эффективности: звонки, КП, счета, конверсия" },
  { name: "Отчет по клиентской базе", type: "clients", lastGenerated: "2026-06-15", autoSchedule: true, description: "Анализ активных, уснувших, новых клиентов, сегментация" },
  { name: "Отчет по уснувшим клиентам", type: "dormant", lastGenerated: "2026-06-18", autoSchedule: true, description: "Клиенты без покупок > 30 дней, потенциал возврата" },
  { name: "Отчет по снижению закупок", type: "decline", lastGenerated: "2026-06-19", autoSchedule: true, description: "Клиенты со снижением объема закупок, анализ причин" },
  { name: "Отчет по счетам без оплаты", type: "unpaid", lastGenerated: "2026-06-22", autoSchedule: true, description: "Неоплаченные и просроченные счета с суммами и сроками" },
  { name: "Отчет по дебиторской задолженности", type: "debt", lastGenerated: "2026-06-22", autoSchedule: true, description: "Просроченная дебиторка по клиентам и менеджерам" },
  { name: "Отчет по воронке продаж", type: "funnel", lastGenerated: "2026-06-16", autoSchedule: true, description: "Конверсия по этапам, проблемные зоны, потери" },
  { name: "Отчет по зависшим сделкам", type: "stuck", lastGenerated: "2026-06-22", autoSchedule: true, description: "Сделки без движения, сроки зависания, суммы" },
  { name: "Отчет по потерянным сделкам", type: "lost", lastGenerated: "2026-06-14", autoSchedule: true, description: "Причины отказов, упущенная выручка, анализ конкурентов" },
  { name: "Отчет по повторным продажам", type: "repeat", lastGenerated: "2026-06-12", autoSchedule: true, description: "Потенциал возврата клиентов, допродажи, категории" },
  { name: "План / факт продаж", type: "plan_fact", lastGenerated: "2026-06-20", autoSchedule: true, description: "Сравнение плана и факта по выручке, марже и конверсии" },
  { name: "Прогноз продаж до конца месяца", type: "forecast", lastGenerated: "2026-06-15", autoSchedule: true, description: "Прогноз на основании текущей воронки и истории закрытия" },
];

export const stuckDeals: StuckDeal[] = [
  { id: "Т000-000116", client: "АО Модный Дом", manager: "Иванов А.С.", amount: 2190000, daysWithoutAction: 5, lastAction: "Отправлено КП 2026-03-08" },
  { id: "Т000-000118", client: "ООО Швейное Объединение Восток", manager: "Сидорова Е.М.", amount: 1520000, daysWithoutAction: 8, lastAction: "Встреча 2026-05-15" },
  { id: "Т000-000115", client: "ООО Домашний Текстиль", manager: "Сидорова Е.М.", amount: 215000, daysWithoutAction: 12, lastAction: "Счет выставлен 2026-02-14" },
  { id: "Т000-000123", client: "ООО ТекстильПро", manager: "Петров Д.Н.", amount: 536000, daysWithoutAction: 2, lastAction: "Заказ подтвержден 2026-06-21" },
  { id: "Т000-000127", client: "ООО ТексПром", manager: "Сидорова Е.М.", amount: 92000, daysWithoutAction: 45, lastAction: "Письмо о сроках 2026-04-01" },
  { id: "Т000-000124", client: "АО Модный Дом", manager: "Сидорова Е.М.", amount: 945000, daysWithoutAction: 2, lastAction: "Заказ подтвержден 2026-06-21" },
  { id: "Т000-000129", client: "ООО Гардинная Мануфактура", manager: "Петров Д.Н.", amount: 204000, daysWithoutAction: 22, lastAction: "Счет выставлен 2026-01-10" },
  { id: "Т000-000130", client: "ООО Швейная Фабрика №1", manager: "Сидорова Е.М.", amount: 575000, daysWithoutAction: 18, lastAction: "Звонок 2026-03-20" },
  { id: "Т000-000128", client: "ООО Мебельный Текстиль", manager: "Иванов А.С.", amount: 156000, daysWithoutAction: 75, lastAction: "Письмо 2025-09-05" },
  { id: "Т000-000126", client: "ООО Спецодежда Плюс", manager: "Петров Д.Н.", amount: 738000, daysWithoutAction: 2, lastAction: "Заказ подтвержден 2026-06-22" },
  { id: "Т000-000125", client: "ООО Домашний Текстиль", manager: "Иванов А.С.", amount: 380000, daysWithoutAction: 1, lastAction: "Заказ подтвержден 2026-06-22" },
  { id: "Т000-000114", client: "ООО ТекстильПро", manager: "Петров Д.Н.", amount: 648000, daysWithoutAction: 4, lastAction: "Письмо 2026-01-25" },
  { id: "Т000-000112", client: "ООО Мебельный Текстиль", manager: "Сидорова Е.М.", amount: 495000, daysWithoutAction: 6, lastAction: "Звонок 2025-12-02" },
  { id: "Т000-000111", client: "АО Модный Дом", manager: "Петров Д.Н.", amount: 1860000, daysWithoutAction: 3, lastAction: "Письмо 2025-11-14" },
];

export const dormantClients: DormantClient[] = [
  { name: "ООО Мебельный Текстиль", manager: "Иванов А.С.", lastOrderDate: "2025-12-02", daysSinceOrder: 203, totalRevenue: 651000, avgOrder: 325500 },
  { name: "ООО ТексПром", manager: "Сидорова Е.М.", lastOrderDate: "2026-04-22", daysSinceOrder: 62, totalRevenue: 714000, avgOrder: 357000 },
  { name: "ООО Швейное Объединение Восток", manager: "Сидорова Е.М.", lastOrderDate: "2026-05-15", daysSinceOrder: 38, totalRevenue: 3395000, avgOrder: 1697500 },
  { name: "ООО Спецодежда Плюс", manager: "Иванов А.С.", lastOrderDate: "2026-06-02", daysSinceOrder: 21, totalRevenue: 1788000, avgOrder: 596000 },
  { name: "ООО Гардинная Мануфактура", manager: "Петров Д.Н.", lastOrderDate: "2026-06-10", daysSinceOrder: 13, totalRevenue: 848000, avgOrder: 282667 },
  { name: "ООО Домашний Текстиль", manager: "Сидорова Е.М.", lastOrderDate: "2026-02-14", daysSinceOrder: 129, totalRevenue: 1207000, avgOrder: 402333 },
];

export const unpaidInvoices: UnpaidInvoice[] = [
  { id: "С-536", client: "ООО ТекстильПро", manager: "Петров Д.Н.", amount: 536000, date: "2026-06-21", daysOverdue: 0 },
  { id: "С-126", client: "ООО Спецодежда Плюс", manager: "Петров Д.Н.", amount: 738000, date: "2026-06-22", daysOverdue: 0 },
  { id: "С-115", client: "ООО Домашний Текстиль", manager: "Сидорова Е.М.", amount: 215000, date: "2026-02-14", daysOverdue: 128 },
  { id: "С-129", client: "ООО Гардинная Мануфактура", manager: "Петров Д.Н.", amount: 204000, date: "2026-01-10", daysOverdue: 163 },
  { id: "С-127", client: "ООО ТексПром", manager: "Сидорова Е.М.", amount: 92000, date: "2026-04-01", daysOverdue: 82 },
  { id: "С-104", client: "ООО Спецодежда Плюс", manager: "Иванов А.С.", amount: 325000, date: "2025-04-08", daysOverdue: 441 },
  { id: "С-108", client: "ООО ТекстильПро", manager: "Петров Д.Н.", amount: 432000, date: "2025-08-10", daysOverdue: 316 },
  { id: "С-107", client: "ООО ТексПром", manager: "Иванов А.С.", amount: 168000, date: "2025-07-22", daysOverdue: 335 },
  { id: "С-117", client: "ООО ТексПром", manager: "Петров Д.Н.", amount: 454000, date: "2026-04-22", daysOverdue: 62 },
];

export const aiInsights: AIInsight[] = [
  { type: "stuck_deals", count: 14, description: "сделок без следующего действия", action: "Проставить задачи менеджерам", priority: "Высокий" },
  { type: "dormant_clients", count: 6, description: "клиентов давно не покупали", action: "Запустить реактивацию", priority: "Средний" },
  { type: "unpaid_invoices", count: 9, description: "счетов нужно дожать до оплаты", action: "Назначить звонки", priority: "Высокий" },
  { type: "create_tasks", count: 12, description: "задач можно создать автоматически", action: "Автосоздание задач", priority: "Высокий" },
  { type: "declining", count: 5, description: "клиентов снизили закупки", action: "Выяснить причины", priority: "Высокий" },
  { type: "lost_deals", count: 7, description: "потерянных сделок за месяц", action: "Проанализировать отказы", priority: "Средний" },
];

export const managerHelpItems = [
  "Что делать дальше с клиентом АО Модный Дом",
  "Подсказки по клиенту ООО Швейное Объединение Восток",
  "Шаблоны сообщений для дожима оплаты",
  "Рекомендации по допродажам тканей",
  "Сценарий разговора для уснувших клиентов",
  "Чек-лист подготовки к встрече",
];

export const lostDeals: LostDeal[] = [
  { id: "Т000-000098", client: "ООО Швейная Фабрика №1", manager: "Иванов А.С.", amount: 850000, stage: "Презентация / КП", reason: "Ушли к конкурентам (цена ниже на 12%)", lostDate: "2026-06-10" },
  { id: "Т000-000101", client: "АО Модный Дом", manager: "Петров Д.Н.", amount: 1420000, stage: "Согласование условий", reason: "Не устроили сроки поставки (требовали 5 дней)", lostDate: "2026-06-05" },
  { id: "Т000-000103", client: "ООО Спецодежда Плюс", manager: "Сидорова Е.М.", amount: 620000, stage: "Презентация / КП", reason: "Ушли к конкурентам (шире ассортимент)", lostDate: "2026-06-12" },
  { id: "Т000-000105", client: "ООО Домашний Текстиль", manager: "Иванов А.С.", amount: 380000, stage: "Счёт выставлен", reason: "Отсрочка платежа не согласована", lostDate: "2026-05-28" },
  { id: "Т000-000106", client: "ООО Гардинная Мануфактура", manager: "Петров Д.Н.", amount: 510000, stage: "Выявление потребности", reason: "Цена выше рынка на 15%", lostDate: "2026-06-15" },
  { id: "Т000-000107", client: "ООО ТекстильПро", manager: "Сидорова Е.М.", amount: 295000, stage: "Презентация / КП", reason: "Не соответствие образцов ожиданиям", lostDate: "2026-06-08" },
  { id: "Т000-000109", client: "ООО ТексПром", manager: "Иванов А.С.", amount: 178000, stage: "Первичный контакт", reason: "Нет потребности в текущем ассортименте", lostDate: "2026-06-18" },
];

export const unansweredOffers: UnansweredOffer[] = [
  { id: "КП-042", client: "АО Модный Дом", manager: "Петров Д.Н.", amount: 1860000, sentDate: "2026-06-10", daysWithoutAnswer: 7 },
  { id: "КП-044", client: "ООО Швейное Объединение Восток", manager: "Сидорова Е.М.", amount: 1520000, sentDate: "2026-06-03", daysWithoutAnswer: 14 },
  { id: "КП-045", client: "ООО Спецодежда Плюс", manager: "Иванов А.С.", amount: 738000, sentDate: "2026-06-08", daysWithoutAnswer: 9 },
  { id: "КП-046", client: "ООО Гардинная Мануфактура", manager: "Петров Д.Н.", amount: 510000, sentDate: "2026-05-28", daysWithoutAnswer: 20 },
  { id: "КП-047", client: "ООО Мебельный Текстиль", manager: "Сидорова Е.М.", amount: 495000, sentDate: "2026-05-22", daysWithoutAnswer: 26 },
];

export const decliningClients: DecliningClient[] = [
  { name: "ООО Швейное Объединение Восток", manager: "Сидорова Е.М.", prevRevenue: 4527000, currentRevenue: 3395000, declinePercent: 25, lastOrderDate: "2026-05-15" },
  { name: "ООО Спецодежда Плюс", manager: "Иванов А.С.", prevRevenue: 1987000, currentRevenue: 1788000, declinePercent: 10, lastOrderDate: "2026-06-02" },
  { name: "ООО Домашний Текстиль", manager: "Сидорова Е.М.", prevRevenue: 1472000, currentRevenue: 1207000, declinePercent: 18, lastOrderDate: "2026-06-22" },
  { name: "ООО ТексПром", manager: "Сидорова Е.М.", prevRevenue: 1190000, currentRevenue: 714000, declinePercent: 40, lastOrderDate: "2026-04-22" },
  { name: "ООО Мебельный Текстиль", manager: "Иванов А.С.", prevRevenue: 1447000, currentRevenue: 651000, declinePercent: 55, lastOrderDate: "2025-12-02" },
];

export const forgottenClients: ForgottenClient[] = [
  { name: "ООО Мебельный Текстиль", manager: "Иванов А.С.", lastContactDate: "2025-12-02", daysWithoutContact: 227, totalRevenue: 651000 },
  { name: "ООО ТексПром", manager: "Сидорова Е.М.", lastContactDate: "2026-04-01", daysWithoutContact: 107, totalRevenue: 714000 },
  { name: "ООО Домашний Текстиль", manager: "Сидорова Е.М.", lastContactDate: "2026-03-15", daysWithoutContact: 124, totalRevenue: 1207000 },
  { name: "ООО Гардинная Мануфактура", manager: "Петров Д.Н.", lastContactDate: "2026-05-10", daysWithoutContact: 68, totalRevenue: 848000 },
];

export const repeatSalePotentials: RepeatSalePotential[] = [
  { client: "ООО Мебельный Текстиль", manager: "Иванов А.С.", previousRevenue: 651000, potentialRevenue: 450000, category: "Мебельные ткани", reason: "Цикл закупок: последний заказ 203 дня назад — высокая вероятность возврата со скидкой 7%" },
  { client: "ООО ТексПром", manager: "Сидорова Е.М.", previousRevenue: 714000, potentialRevenue: 520000, category: "Костюмные ткани", reason: "Сезонный спрос: ранее закупали костюмную ткань, сезон осень-зима 2026" },
  { client: "ООО Швейное Объединение Восток", manager: "Сидорова Е.М.", previousRevenue: 3395000, potentialRevenue: 1800000, category: "Трикотаж", reason: "Снижение на 25% — потенциал восстановления через персональное КП на трикотаж" },
  { client: "ООО Домашний Текстиль", manager: "Сидорова Е.М.", previousRevenue: 1207000, potentialRevenue: 350000, category: "Подкладочные ткани", reason: "Долг 215 000 ₽, после погашения — допродажа подкладочных тканей" },
];

export const aiTaskSuggestions: AITaskSuggestion[] = [
  { id: "AI-001", title: "Проанализировать падение конверсии на этапе «Презентация / КП» — 55% вместо целевых 70%", assignee: "РОП", client: "Все отделы", reason: "10 сделок потеряно на этом этапе, упущено 2 130 000 ₽", priority: "Критично", confirmed: false },
  { id: "AI-002", title: "Провести встречу с Петровым Д.Н. по дисциплине задач — отставание 4% от среднего", assignee: "РОП", client: "1 отдел", reason: "Дисциплина 88% при среднем 92%, также конверсия КП→счёт на 8% ниже", priority: "Высокий", confirmed: false },
  { id: "AI-003", title: "Утвердить план реактивации для 6 уснувших клиентов", assignee: "РОП", client: "Все отделы", reason: "Потенциал возврата 3 120 000 ₽, 4 клиента без контакта более 60 дней", priority: "Высокий", confirmed: false },
  { id: "AI-004", title: "Проверить отчёт по дебиторской задолженности — просрочено 3 164 000 ₽", assignee: "РОП", client: "Все отделы", reason: "5 счетов с просрочкой более 60 дней, 1 счёт просрочен на 441 день", priority: "Критично", confirmed: false },
  { id: "AI-005", title: "Скорректировать скрипты и шаблоны КП — 7 сделок потеряно из-за цены и слабых презентаций", assignee: "РОП", client: "Все отделы", reason: "Основные причины отказов: «цена выше рынка» и «ушли к конкурентам»", priority: "Средний", confirmed: false },
  { id: "AI-006", title: "Провести аудит работы с КП без ответа — 5 КП на сумму 5 675 000 ₽", assignee: "РОП", client: "Все отделы", reason: "Максимальный срок без ответа — 26 дней, риск потери 5 675 000 ₽", priority: "Высокий", confirmed: false },
  { id: "AI-007", title: "Организовать тренинг по технике переговоров для 1 и 3 отделов", assignee: "РОП", client: "1 и 3 отделы", reason: "Конверсия Счёт→Оплата 75% — ниже целевых 85%, 3 сделки потеряны на этом этапе", priority: "Средний", confirmed: false },
  { id: "AI-008", title: "Проверить прогноз выполнения плана продаж на месяц — текущее выполнение 91.4%", assignee: "РОП", client: "Все отделы", reason: "Осталось 13 дней, план по выручке 15 000 000 ₽, факт 13 706 000 ₽", priority: "Средний", confirmed: false },
  { id: "AI-009", title: "Разобрать причины потери сделки с АО Модный Дом на 1 420 000 ₽", assignee: "РОП", client: "АО Модный Дом", reason: "Клиент из топ-2 по выручке, отказ из-за сроков поставки — системная проблема", priority: "Высокий", confirmed: false },
  { id: "AI-010", title: "Пересмотреть KPI для отстающих менеджеров на следующий месяц", assignee: "РОП", client: "Все отделы", reason: "3 менеджера ниже среднего по ключевым метрикам, требуется корректировка планов", priority: "Низкий", confirmed: false },
];

export const departmentWeakSpots: DepartmentWeakSpot[] = [
  { stage: "Презентация / КП", issue: "Конверсия 55% — самая низкая в воронке. 10 сделок потеряно на этом этапе.", lostRevenue: 2130000, recommendation: "Обучение менеджеров технике презентации, шаблоны КП с расчётом ROI для клиента" },
  { stage: "Выявление потребности", issue: "7 клиентов ушли после первого контакта — менеджеры не выявляют реальные боли.", lostRevenue: 1560000, recommendation: "Внедрить чек-лист выявления потребностей, скрипт углубленных вопросов" },
  { stage: "Счёт выставлен", issue: "3 счёта не оплачены вовремя, 2 потеряны из-за условий отсрочки.", lostRevenue: 595000, recommendation: "Автоматическое напоминание об оплате за 2 дня до срока, согласование отсрочек с РОПом" },
];

export const managersLagging: ManagerLagging[] = [
  { name: "Петров Д.Н.", metric: "Дисциплина задач", value: "88%", departmentAvg: "92%", gap: "-4%" },
  { name: "Петров Д.Н.", metric: "Конверсия КП→счёт", value: "67%", departmentAvg: "75%", gap: "-8%" },
  { name: "Иванов А.С.", metric: "Средний чек", value: "382 000 ₽", departmentAvg: "457 000 ₽", gap: "-75 000 ₽" },
  { name: "Сидорова Е.М.", metric: "Новых клиентов", value: "3", departmentAvg: "3.3", gap: "-0.3" },
];

export const activeClientsCount = 248;
export const stuckDealsCount = 14;
export const unpaidInvoicesCount = 9;
export const overdueTasksCount = 17;
export const unansweredOffersCount = 5;
export const decliningClientsCount = 5;
export const lostDealsCount = 7;
export const forgottenClientsCount = 4;

export const planRevenue = 15000000;
export const factRevenue = 13706000;
export const planMargin = 4500000;
export const factMargin = 4111800;
export const forecastRevenue = 15800000;
export const forecastMargin = 4740000;

export const totalLostRevenue = 4253000;
export const totalRepeatPotential = 3120000;
export const totalOverdueDebt = 3164000;

export const departments: DepartmentData[] = [
  {
    name: "1 отдел",
    managers: [
      { name: "Иванов А.С.", grade: "Ведущий менеджер", rating: 11, maxRating: 15, activeDeals: 15, activeDealsAmount: 4582000, unansweredOffers: 3, unansweredOffersAmount: 1250000, ordersInProgress: 9, ordersInProgressAmount: 3120000, warehouseAssembly: 3, deliveriesToday: 5, clientsWithDebt: 3, debtAmount: 593000, paymentsToday: 4, paymentsAmount: 1850000 },
      { name: "Петров Д.Н.", grade: "Менеджер", rating: 7, maxRating: 15, activeDeals: 12, activeDealsAmount: 3942000, unansweredOffers: 4, unansweredOffersAmount: 1860000, ordersInProgress: 7, ordersInProgressAmount: 2650000, warehouseAssembly: 2, deliveriesToday: 4, clientsWithDebt: 2, debtAmount: 740000, paymentsToday: 3, paymentsAmount: 1420000 },
      { name: "Смирнова О.В.", grade: "Менеджер", rating: 8, maxRating: 15, activeDeals: 10, activeDealsAmount: 2830000, unansweredOffers: 2, unansweredOffersAmount: 680000, ordersInProgress: 6, ordersInProgressAmount: 1980000, warehouseAssembly: 2, deliveriesToday: 3, clientsWithDebt: 2, debtAmount: 420000, paymentsToday: 3, paymentsAmount: 1120000 },
      { name: "Григорьев А.М.", grade: "Менеджер", rating: 9, maxRating: 15, activeDeals: 11, activeDealsAmount: 3150000, unansweredOffers: 3, unansweredOffersAmount: 1050000, ordersInProgress: 7, ordersInProgressAmount: 2450000, warehouseAssembly: 2, deliveriesToday: 4, clientsWithDebt: 2, debtAmount: 485000, paymentsToday: 3, paymentsAmount: 1350000 },
      { name: "Королёва Е.Д.", grade: "Менеджер", rating: 6, maxRating: 15, activeDeals: 9, activeDealsAmount: 2650000, unansweredOffers: 2, unansweredOffersAmount: 580000, ordersInProgress: 5, ordersInProgressAmount: 1850000, warehouseAssembly: 2, deliveriesToday: 3, clientsWithDebt: 1, debtAmount: 310000, paymentsToday: 2, paymentsAmount: 950000 },
    ],
  },
  {
    name: "2 отдел",
    managers: [
      { name: "Сидорова Е.М.", grade: "Ведущий менеджер", rating: 12, maxRating: 15, activeDeals: 14, activeDealsAmount: 5182000, unansweredOffers: 5, unansweredOffersAmount: 2010000, ordersInProgress: 8, ordersInProgressAmount: 3450000, warehouseAssembly: 4, deliveriesToday: 6, clientsWithDebt: 3, debtAmount: 307000, paymentsToday: 5, paymentsAmount: 2100000 },
      { name: "Кузнецов В.А.", grade: "Менеджер", rating: 8, maxRating: 15, activeDeals: 11, activeDealsAmount: 3520000, unansweredOffers: 3, unansweredOffersAmount: 950000, ordersInProgress: 7, ordersInProgressAmount: 2340000, warehouseAssembly: 3, deliveriesToday: 4, clientsWithDebt: 2, debtAmount: 525000, paymentsToday: 4, paymentsAmount: 1680000 },
      { name: "Федорова Н.П.", grade: "Менеджер", rating: 7, maxRating: 15, activeDeals: 9, activeDealsAmount: 2750000, unansweredOffers: 2, unansweredOffersAmount: 720000, ordersInProgress: 5, ordersInProgressAmount: 1890000, warehouseAssembly: 2, deliveriesToday: 3, clientsWithDebt: 1, debtAmount: 215000, paymentsToday: 3, paymentsAmount: 980000 },
    ],
  },
  {
    name: "3 отдел",
    managers: [
      { name: "Морозов И.Г.", grade: "Ведущий менеджер", rating: 10, maxRating: 15, activeDeals: 13, activeDealsAmount: 4230000, unansweredOffers: 4, unansweredOffersAmount: 1580000, ordersInProgress: 8, ordersInProgressAmount: 2980000, warehouseAssembly: 3, deliveriesToday: 5, clientsWithDebt: 3, debtAmount: 632000, paymentsToday: 4, paymentsAmount: 1950000 },
      { name: "Васильева Т.С.", grade: "Менеджер", rating: 8, maxRating: 15, activeDeals: 10, activeDealsAmount: 3180000, unansweredOffers: 3, unansweredOffersAmount: 840000, ordersInProgress: 6, ordersInProgressAmount: 2120000, warehouseAssembly: 2, deliveriesToday: 4, clientsWithDebt: 2, debtAmount: 375000, paymentsToday: 3, paymentsAmount: 1250000 },
      { name: "Николаев П.Р.", grade: "Менеджер", rating: 6, maxRating: 15, activeDeals: 8, activeDealsAmount: 2560000, unansweredOffers: 2, unansweredOffersAmount: 610000, ordersInProgress: 5, ordersInProgressAmount: 1780000, warehouseAssembly: 2, deliveriesToday: 3, clientsWithDebt: 1, debtAmount: 198000, paymentsToday: 2, paymentsAmount: 870000 },
      { name: "Тарасов С.В.", grade: "Менеджер", rating: 9, maxRating: 15, activeDeals: 12, activeDealsAmount: 3850000, unansweredOffers: 3, unansweredOffersAmount: 1120000, ordersInProgress: 7, ordersInProgressAmount: 2550000, warehouseAssembly: 3, deliveriesToday: 4, clientsWithDebt: 2, debtAmount: 520000, paymentsToday: 3, paymentsAmount: 1480000 },
    ],
  },
];

export interface KpiTargetValues {
  calls: number;
  proposals: number;
  newClients: number;
  revenue: number;
  margin: number;
  meetings: number;
  invoices: number;
  payments: number;
}

export interface KpiTargets {
  [grade: string]: KpiTargetValues;
}

export const defaultKpiTargets: KpiTargets = {
  "Менеджер": {
    calls: 40,
    proposals: 15,
    newClients: 3,
    revenue: 4000000,
    margin: 1200000,
    meetings: 10,
    invoices: 8,
    payments: 6,
  },
  "Ведущий менеджер": {
    calls: 55,
    proposals: 22,
    newClients: 5,
    revenue: 6500000,
    margin: 1950000,
    meetings: 15,
    invoices: 12,
    payments: 10,
  },
};